import { Typography } from '@mui/material';
import { useField, FieldArray } from 'formik';

import { AddButton } from 'components';

import { FormCheckboxFieldProps } from './types';
import { OtherOptionRow } from './other-option-row';
import { ChoiceOptionRow } from './choice-option-row';
import { getAlignedAnswerValues } from './answer-values';
import { RandomizeOptionsField } from './randomize-options';

export const FormCheckboxField = ({
  name,
  value,
  allowReferenceCodes = false,
}: FormCheckboxFieldProps) => {
  const items = value.options?.options ?? [];
  const [, { value: answerValuesValue }, { setValue: setAnswerValuesValue }] =
    useField<string[] | undefined>(`${name}.options.answerValues`);
  const answerValues = Array.isArray(answerValuesValue)
    ? answerValuesValue
    : [];
  const alignedAnswerValues = getAlignedAnswerValues(
    answerValues,
    items.length
  );

  return (
    <div className="flex flex-col gap-4">
      <RandomizeOptionsField name={name} />
      <OtherOptionRow name={name} allowReferenceCodes={allowReferenceCodes} />
      <FieldArray
        name={`${name}.options.options`}
        render={({ push, remove }) => (
          <div className="flex flex-col gap-4">
            <Typography variant="h6">Checkbox Options</Typography>

            {items.map((_, idx) => (
              <ChoiceOptionRow
                idx={idx}
                key={idx}
                name={name}
                remove={remove}
                itemsLength={items.length}
                optionLabel="Checkbox option"
                answerValues={alignedAnswerValues}
                allowReferenceCodes={allowReferenceCodes}
                setAnswerValuesValue={setAnswerValuesValue}
              />
            ))}

            <AddButton
              title="option"
              onClick={() => {
                push('');
                setAnswerValuesValue([...alignedAnswerValues, ''], false);
              }}
            />
          </div>
        )}
      />
    </div>
  );
};
